export enum ReportType {
    None = "",
    Balances = "Balances",
    Transactions = "Transactions",
    PaymentFunnel = "PaymentFunnel",
}